// @flow
/* eslint-disable @gandi/gandi/no-global-element */

import * as React from 'react';

import { useTranslator } from '@gandi/translate';

import styles from './ChatWithUsButton.scss';

type Props = {
  onClick: (SyntheticMouseEvent<>) => mixed,
};

export default function ChatWithUsButton({
  onClick,
}: Props): React.MixedElement {
  const { __ } = useTranslator();

  return (
    <button type="button" className={styles.closed} onClick={onClick}>
      <div className={styles.containerIcon}>
        <svg width="17" height="17" viewBox="0 0 17 17" className={styles.icon}>
          <path
            fill="#FFF"
            fillRule="evenodd"
            d="M4.5,-3.55271368e-15 L12.5,-3.55271368e-15 C14.9852814,-4.00925246e-15 17,2.01471863 17,4.5 L17,8.25 C17,10.7352814 14.9852814,12.75 12.5,12.75 L8.92904948,12.75 L8.92904948,12.75 L5.43195191,16.599851 L5.43195191,12.75 L4.5,12.75 C2.01471863,12.75 1.40804583e-15,10.7352814 0,8.25 L0,4.5 C-3.04359188e-16,2.01471863 2.01471863,-3.0961749e-15 4.5,-3.55271368e-15 Z"
          />
        </svg>
      </div>
      <div className={styles.text}>{__('Chat with us')}</div>
    </button>
  );
}
